import React from 'react'
import i18n from 'src/i18n'
import { Formik } from 'formik'
import { object, string } from 'yup'
import localStorageWrapper from 'src/util/localStorageWrapper'

import { useStore, actions } from 'store'

import { TextInput } from '@ /amazon'

import { Layout, FormBottomButtons, LoginBlock } from 'components'

const t = i18n.t.bind(i18n)

export const validationSchema = new object().shape({
  loginEmail: new string()
    .required(t('formErrors:required'))
    .email(t('formErrors:invalid.email')),
})

const AskForEmail = () => {
  const [, dispatch] = useStore()
  const handleSubmit = async ({ loginEmail }, bag) => {
    localStorageWrapper.setItem('loginEmail', loginEmail)
    dispatch(actions.setLoginInfo({ loginEmail }))
  }

  return (
    <Layout>
      <LoginBlock
        title="E-mail bevestigen ter controle"
        message="Omdat jij jouw magische link hebt aangevraagd in een andere browser dien je je e-mailadres eerst te bevestigen."
      >
        <Formik
          initialValues={{ loginEmail: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleSubmit,
            isSubmitting,
            handleReset,
            submitForm,
            validateForm,
            errors,
            ...props
          }) => (
            <form onSubmit={handleSubmit}>
              <TextInput name="loginEmail" />
              <FormBottomButtons
                noPrevious
                isSubmitting={isSubmitting}
                submit={submitForm}
                fkey="signInLinkConfirmEmail"
              />
            </form>
          )}
        </Formik>
      </LoginBlock>
    </Layout>
  )
}

export default AskForEmail
